export default {
  id: 'teams_gamification_individual',
  title: 'Gamification - Individual',
  type: 'Direct',
  description: 'Message the overall standing of the collective goal and leaderboard to the participants.',
  body: `<div>
    <div style="padding-bottom: 10px">[[INPUT_PRE_LEADERBOARD_TEXT]]</div>
    <p style="font-size: 16px; padding-bottom: 4px">{{COLLECTIVE_GOAL_ICON}} <strong>{{COLLECTIVE_GOAL_HEADLINE}}</strong></p>
    <p style="margin-top: 5px; margin-bottom: 10px;"><strong>{{COLLECTIVE_GOAL_PROGRESS}} {{COLLECTIVE_GOAL_FIRST_LINE}}</strong> {{COLLECTIVE_GOAL_SECOND_LINE}}</p>
    <table style="border:0; border-radius: 5px; border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; overflow: hidden" cellpadding="0" cellspacing="0" width="100%">
      <tr>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">🔵</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">🔵</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">🔵</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">🔵</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">⚪️</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">⚪️</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">⚪️</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">⚪️</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">⚪️</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">⚪️</td>
      </tr>
    </table>
    <hr />
    <p style="font-size: 16px; padding-bottom: 10px"><strong>Leaderboard</strong></p>
    <table style="border: 0; mso-table-lspace: 0pt; mso-table-rspace: 0pt; overflow: hidden; background-color:rgba(0, 0, 0, 0);" cellpadding="0" cellspacing="0" width="100%">
      <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">🥇</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_FIRST_NAME}}</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_FIRST_POINTS}} points</td>
      </tr>
      <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">🥈</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_SECOND_NAME}}</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_SECOND_POINTS}} points</td>
      </tr>
      <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">🥉</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_THIRD_NAME}}</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_THIRD_POINTS}} points</td>
      </tr>
      <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">...</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);"></td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);"></td>
      </tr>
      <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_POSITION}}</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{FIRST_NAME}} {{LAST_NAME}}</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_POINTS}} points</td>
      </tr>
    </table>
    <div style="padding-top: 15px">[[INPUT_POST_LEADERBOARD_TEXT]]</div>
  </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
  inputs: {
    INPUT_PRE_LEADERBOARD_TEXT: {
      label: 'Text before leaderboard',
      placeholder: 'Hi All ...',
      defaultValue: '<p>Hi All,</p><p>The current standing of the leaderboard and collective goal is the following</p>',
      type: 'HTML'
    },
    INPUT_POST_LEADERBOARD_TEXT: {
      label: 'Text after leaderboard',
      placeholder: 'Come back to the platform to earn awesome rewards...',
      defaultValue: '<p>Come back to the platform to earn awesome rewards.<br>{{PLATFORM_LINK}}</p>',
      type: 'HTML'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/gamificationUpdateIndividual.js